export default __webpack_public_path__ + "static/2-ceee44a04aa2e939ac55305316be7bd2.webp";